<script setup>
const props = defineProps({
    content: {
        type: Object,
        required: true
    }
})
</script>
<template>
    <img
        :src="content.title"
        class="overflow-hidden rounded-wl shadow-custom"
    />
</template>
